import { useEffect } from "react";
import CurrentOpenings from "./components/currentOpenings";
import { IStudentCareerPath } from "../../../models/student/studentCareerPath";
import { connect, useDispatch } from "react-redux";
import { setDescriptionText } from "../../../store/slices/common/commonSlice";
import { getDescriptionText } from "../../../action/common/commonActionCreator";
import { pageBlockId } from "../../../constants/pageBlocks";
import { getPageBlockData } from "../../../common-functions/commonFunctions";
import { baseURL } from "../../../constants/commonConstants";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { careerPathDescription, careerPathTitle } from "./careerPathConstants";

const StudentCareerPath = (props: IStudentCareerPath) => {
  const { getDescriptionText, description, snapShots, getSnapShots } = props;

  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.studentCareerPath
  );

  useEffect(() => {
    getDescriptionText(pageBlockId.studentCareerPath);
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setDescriptionText([]));
    };
  }, []);

  return (
    <>
      <div className="row studcareer-mobile">
        <div className="col-lg-12">
          <div
            className={
              pageBlockData?.displayOrNot
                ? "card-wrap h-career"
                : "card-wrap card-snapshot"
            }
            style={
              pageBlockData?.displayOrNot === false
                ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
                : {}
            }
          >
            <div className="jobintro">
              <div className="title">
                <h2 className="mb-28">Launch Your Career Journey</h2>
              </div>
              {pageBlockData?.displayOrNot && (
                <div className="desc">
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="img">
                        <img
                          src={
                            description?.image
                              ? `${baseURL}${description.image}`
                              : "/assets/images/careers.png"
                          }
                          alt=""
                          className="w-100"
                        />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <h6 className="mb-3 fs-6 fw-semibold">
                        {description?.title
                          ? description.title
                          : careerPathTitle}
                      </h6>
                      <p className="mb-3">
                        {description?.description
                          ? description.description
                          : careerPathDescription}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {pageBlockData?.displayOrNot && <CurrentOpenings />}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="careersview"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="editdepartementLabel"
        aria-hidden="true"
      ></div>
    </>
  );
};

const mapDispatchToProps = {
  getDescriptionText: (pageBlockId: number) => getDescriptionText(pageBlockId),
  getSnapShots: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    description: state.common.descriptionText,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentCareerPath);
